// Constantes de permissões RBAC compartilhadas

export const PERMISSIONS = {
  // Eventos
  EVENT_CREATE: "event:create",
  EVENT_READ: "event:read",
  EVENT_UPDATE: "event:update",
  EVENT_DELETE: "event:delete",
  
  // Participantes
  PARTICIPANT_IMPORT: "participant:import",
  PARTICIPANT_CREATE: "participant:create",
  PARTICIPANT_READ: "participant:read",
  PARTICIPANT_UPDATE: "participant:update",
  PARTICIPANT_DELETE: "participant:delete",
  
  // Agenda
  AGENDA_GENERATE: "agenda:generate",
  AGENDA_READ_ALL: "agenda:read:all",
  AGENDA_READ_OWN: "agenda:read:own",
  AGENDA_UPDATE: "agenda:update",
  
  // Reuniões
  MEETING_CREATE: "meeting:create",
  MEETING_READ_ALL: "meeting:read:all",
  MEETING_READ_OWN: "meeting:read:own",
  MEETING_UPDATE_STATUS: "meeting:update:status",
  MEETING_MOVE: "meeting:move",
  
  // Usuários
  USER_CREATE: "user:create",
  USER_READ: "user:read",
  USER_UPDATE: "user:update",
  USER_DELETE: "user:delete",
  USER_UPDATE_STATUS: "user:update:status",
  USER_UPDATE_ROLE: "user:update:role",
  
  // Painel
  DASHBOARD_VIEW: "dashboard:view",
  
  // Branding
  BRANDING_UPDATE: "branding:update",
} as const;

export type PermissionValue = typeof PERMISSIONS[keyof typeof PERMISSIONS];